import { render, staticRenderFns } from "./SectionRecordings.vue?vue&type=template&id=486dd328&scoped=true&"
import script from "./SectionRecordings.vue?vue&type=script&lang=js&"
export * from "./SectionRecordings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dd328",
  null
  
)

export default component.exports